<template>
  <Loading v-if="!fullyLoaded" />
  <ChemicalForm
    v-else
    :chemicalTypes="chemicalTypes"
    :chemicalManufacturers="chemicalManufacturers"
    :submit="submit"
    :cancel="cancel"
  />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/chemicals_service';
import ChemicalTypeService from '@/services/resources/chemical_types_service';
import ChemicalManufacturerService from '@/services/resources/chemical_manufacturers_service';

export default {
  mixins: [CreateView],
  components: {
    ChemicalForm: () => import('@/components/forms/ChemicalForm.vue'),
  },
  data() {
    return {
      urlFragment: 'chemicals',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicalTypes: {
      get() {
        return ChemicalTypeService.index().then((types) => {
          return types.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    chemicalManufacturers: {
      get() {
        return ChemicalManufacturerService.index().then((manufacturers) => {
          return manufacturers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
